<template>
    <div class="bd">
        <div class="my-custom-table">
            <a-page-header title="回调与通知" />
            <a-tabs v-model:activeKey="activeTab" @change="onTabChange" class="tab-container">
                <!-- 微信回调记录（审计查询） -->
                <a-tab-pane key="notify" tab="微信回调记录">
                    <div class="search-bar">
                        <div class="tabInput">
                            <a class="query-label">支付单号：</a>
                            <a-input v-model:value="notifyQuery.outTradeNo" placeholder="请输入支付单号" class="search-input"
                                allow-clear @press-enter="onNotifySearch" />
                        </div>
                        <div class="tabInput">
                            <a class="query-label">验签：</a>
                            <a-select v-model:value="notifyQuery.verifyStatus" placeholder="请选择" class="search-select"
                                allow-clear :options="VERIFY_OPTIONS" />
                        </div>
                        <div class="tabInput">
                            <a class="query-label">处理：</a>
                            <a-select v-model:value="notifyQuery.processStatus" placeholder="请选择" class="search-select"
                                allow-clear :options="PROCESS_OPTIONS" />
                        </div>
                        <div class="tabInput">
                            <a class="query-label">开始时间：</a>
                            <a-date-picker v-model:value="notifyQuery.beginTime" show-time valueFormat="YYYY-MM-DD HH:mm:ss"
                                placeholder="请选择开始时间" class="search-input" />
                        </div>
                        <div class="tabInput">
                            <a class="query-label">结束时间：</a>
                            <a-date-picker v-model:value="notifyQuery.endTime" show-time valueFormat="YYYY-MM-DD HH:mm:ss"
                                placeholder="请选择结束时间" class="search-input" />
                        </div>
                        <div class="tab-button">
                            <div>
                                <a-button class="search-tow" type="primary" @click="onNotifySearch"
                                    :icon="h(SearchOutlined)">搜索</a-button>
                                <a-button class="search-tow" @click="onNotifyReset" :icon="h(RedoOutlined)">重置</a-button>
                            </div>
                        </div>
                    </div>

                    <a-table :columns="notifyColumns" :data-source="notifyData" :pagination="notifyPagination"
                        row-key="id" :scroll="{ y: 'calc(100vh - 430px)' }" class="flex-table">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'verifyStatus'">
                                <a-tag :color="flagColor(record.verifyStatus)">
                                    {{ flagLabel(VERIFY_OPTIONS, record.verifyStatus) }}
                                </a-tag>
                            </template>
                            <template v-if="column.key === 'processStatus'">
                                <a-tag :color="flagColor(record.processStatus)">
                                    {{ flagLabel(PROCESS_OPTIONS, record.processStatus) }}
                                </a-tag>
                            </template>
                            <template v-if="column.key === 'errorMsg'">
                                {{ record.errorMsg || '-' }}
                            </template>
                            <template v-if="column.dataIndex === 'operation'">
                                <div class="editable-row-operations">
                                    <a @click="showNotifyDetail(record.id)">详情</a>
                                </div>
                            </template>
                        </template>
                    </a-table>
                </a-tab-pane>

                <!-- 业务通知记录（可重推） -->
                <a-tab-pane key="business" tab="业务通知记录">
                    <div class="search-bar">
                        <div class="tabInput">
                            <a class="query-label">支付单号：</a>
                            <a-input v-model:value="businessQuery.outTradeNo" placeholder="请输入支付单号"
                                class="search-input" allow-clear @press-enter="onBusinessSearch" />
                        </div>
                        <div class="tabInput">
                            <a class="query-label">状态：</a>
                            <a-select v-model:value="businessQuery.status" placeholder="请选择" class="search-select"
                                allow-clear :options="NOTIFY_STATUS_OPTIONS" />
                        </div>
                        <div class="tabInput">
                            <a class="query-label">开始时间：</a>
                            <a-date-picker v-model:value="businessQuery.beginTime" show-time
                                valueFormat="YYYY-MM-DD HH:mm:ss" placeholder="请选择开始时间" class="search-input" />
                        </div>
                        <div class="tabInput">
                            <a class="query-label">结束时间：</a>
                            <a-date-picker v-model:value="businessQuery.endTime" show-time
                                valueFormat="YYYY-MM-DD HH:mm:ss" placeholder="请选择结束时间" class="search-input" />
                        </div>
                        <div class="tab-button">
                            <div>
                                <a-button class="search-tow" type="primary" @click="onBusinessSearch"
                                    :icon="h(SearchOutlined)">搜索</a-button>
                                <a-button class="search-tow" @click="onBusinessReset" :icon="h(RedoOutlined)">重置</a-button>
                            </div>
                        </div>
                    </div>

                    <a-table :columns="businessColumns" :data-source="businessData" :pagination="businessPagination"
                        row-key="id" :scroll="{ y: 'calc(100vh - 430px)' }" class="flex-table">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'status'">
                                <a-tag :color="notifyStatusColor(record.status)">
                                    {{ notifyStatusLabel(record.status) }}
                                </a-tag>
                            </template>
                            <template v-if="column.key === 'nextRetryTime'">
                                {{ record.nextRetryTime || '-' }}
                            </template>
                            <template v-if="column.key === 'lastError'">
                                {{ record.lastError || '-' }}
                            </template>
                            <template v-if="column.dataIndex === 'operation'">
                                <div class="editable-row-operations">
                                    <a @click="showBusinessDetail(record.id)">详情</a>
                                    <!-- 已成功的不能重推；回调地址为空时重推必然失败，直接隐藏 -->
                                    <template v-if="record.status !== 1 && record.notifyUrl">
                                        <a-divider type="vertical" />
                                        <a-popconfirm title="将重置为待通知，由支付服务重试任务在 30 秒内自动发送。确认重推？"
                                            ok-text="确认重推" cancel-text="取消" @confirm="retry(record.id)">
                                            <a style="margin: 15px;">重推</a>
                                        </a-popconfirm>
                                    </template>
                                </div>
                            </template>
                        </template>
                    </a-table>
                </a-tab-pane>
            </a-tabs>

            <!-- 微信回调详情 -->
            <a-modal v-model:open="notifyDetailOpen" title="微信回调记录详情" :width="820" :footer="null">
                <a-descriptions bordered :column="1" size="middle">
                    <a-descriptions-item label="回调时间">{{ notifyDetail.createTime || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="支付单号">{{ notifyDetail.outTradeNo || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="验签结果">
                        <a-tag :color="flagColor(notifyDetail.verifyStatus)">
                            {{ flagLabel(VERIFY_OPTIONS, notifyDetail.verifyStatus) }}
                        </a-tag>
                    </a-descriptions-item>
                    <a-descriptions-item label="处理结果">
                        <a-tag :color="flagColor(notifyDetail.processStatus)">
                            {{ flagLabel(PROCESS_OPTIONS, notifyDetail.processStatus) }}
                        </a-tag>
                    </a-descriptions-item>
                    <a-descriptions-item label="错误信息">{{ notifyDetail.errorMsg || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="请求头">
                        <pre class="payload-pre">{{ notifyDetail.headers || '-' }}</pre>
                    </a-descriptions-item>
                    <a-descriptions-item label="回调原始报文">
                        <pre class="payload-pre">{{ notifyDetail.requestBody || '-' }}</pre>
                    </a-descriptions-item>
                </a-descriptions>
                <div class="payload-tip">回调报文为微信回调的加密报文，非明文交易信息，仅供审计追溯。</div>
            </a-modal>

            <!-- 业务通知详情 -->
            <a-modal v-model:open="businessDetailOpen" title="业务通知记录详情" :width="820" :footer="null">
                <a-descriptions bordered :column="1" size="middle">
                    <a-descriptions-item label="支付单号">{{ businessDetail.outTradeNo || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="状态">
                        <a-tag :color="notifyStatusColor(businessDetail.status)">
                            {{ notifyStatusLabel(businessDetail.status) }}
                        </a-tag>
                    </a-descriptions-item>
                    <a-descriptions-item label="回调地址">{{ businessDetail.notifyUrl || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="重试次数">{{ businessDetail.retryCount ?? '-' }}</a-descriptions-item>
                    <a-descriptions-item label="下次重试时间">{{ businessDetail.nextRetryTime || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="最后错误">{{ businessDetail.lastError || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="创建时间">{{ businessDetail.createTime || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="更新时间">{{ businessDetail.updateTime || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="通知报文">
                        <pre class="payload-pre">{{ formatJson(businessDetail.notifyBody) || '-' }}</pre>
                    </a-descriptions-item>
                </a-descriptions>
            </a-modal>
        </div>
    </div>
</template>

<script>
import {
    payNotifyRecordPage, payNotifyRecordInfo,
    payBusinessNotifyPage, payBusinessNotifyInfo, retryPayBusinessNotify
} from '@/api/service';
import { message } from 'ant-design-vue';
import { SearchOutlined, RedoOutlined } from '@ant-design/icons-vue';
import { ref, reactive, h } from 'vue';

// 验签 / 处理：1=通过（成功）、0=失败
const VERIFY_OPTIONS = [
    { value: 1, label: '通过' },
    { value: 0, label: '失败' },
];
const PROCESS_OPTIONS = [
    { value: 1, label: '成功' },
    { value: 0, label: '失败' },
];
// 业务通知状态：0待通知 / 1成功 / 2失败重试中 / 3废弃
const NOTIFY_STATUS_OPTIONS = [
    { value: 0, label: '待通知' },
    { value: 1, label: '成功' },
    { value: 2, label: '失败重试中' },
    { value: 3, label: '废弃' },
];
const NOTIFY_STATUS_MAP = {
    0: { label: '待通知', color: 'blue' },
    1: { label: '成功', color: 'green' },
    2: { label: '失败重试中', color: 'orange' },
    3: { label: '废弃', color: 'default' },
};

export default {
    name: 'BackNoticePage',
    setup() {
        const activeTab = ref('notify');

        // ==================== 微信回调记录 ====================
        const notifyData = ref([]);
        const notifyDetail = ref({});
        const notifyDetailOpen = ref(false);
        const notifyQuery = reactive({
            outTradeNo: '',
            verifyStatus: undefined,
            processStatus: undefined,
            beginTime: '',
            endTime: '',
        });
        const notifyPagination = ref({
            current: 1,
            pageSize: 10,
            total: 0,
            showSizeChanger: true,
            showQuickJumper: true,
            onChange: (page, pageSize) => {
                notifyPagination.value.current = page;
                notifyPagination.value.pageSize = pageSize;
                notifyList();
            },
            position: ['bottomLeft'],
        });
        const notifyColumns = [
            { title: '回调时间', dataIndex: 'createTime', key: 'createTime', width: '16%' },
            { title: '支付单号', dataIndex: 'outTradeNo', key: 'outTradeNo', width: '24%' },
            { title: '验签', dataIndex: 'verifyStatus', key: 'verifyStatus', width: '9%' },
            { title: '处理', dataIndex: 'processStatus', key: 'processStatus', width: '9%' },
            { title: '错误信息', dataIndex: 'errorMsg', key: 'errorMsg', width: '32%' },
            { title: '操作', dataIndex: 'operation', key: 'operation', width: '10%' },
        ];

        const notifyList = async () => {
            const response = await payNotifyRecordPage({
                pageNumber: notifyPagination.value.current,
                pageSize: notifyPagination.value.pageSize,
                outTradeNo: notifyQuery.outTradeNo || undefined,
                // 注意用 ?? ：0 是有效筛选值，不能被 || 吞掉
                verifyStatus: notifyQuery.verifyStatus ?? undefined,
                processStatus: notifyQuery.processStatus ?? undefined,
                beginTime: notifyQuery.beginTime || undefined,
                endTime: notifyQuery.endTime || undefined,
            });
            if (response.code === 200) {
                const page = response.data || {};
                notifyPagination.value.total = page.totalRow || page.total || 0;
                notifyData.value = page.records || [];
            } else {
                message.error(response.msg || '查询失败');
            }
        };

        const showNotifyDetail = async (id) => {
            const response = await payNotifyRecordInfo(id);
            if (response.code === 200) {
                notifyDetail.value = response.data || {};
                notifyDetailOpen.value = true;
            } else {
                message.error(response.msg || '查询详情失败');
            }
        };

        const onNotifySearch = () => {
            notifyPagination.value.current = 1;
            notifyList();
        };

        const onNotifyReset = () => {
            notifyQuery.outTradeNo = '';
            notifyQuery.verifyStatus = undefined;
            notifyQuery.processStatus = undefined;
            notifyQuery.beginTime = '';
            notifyQuery.endTime = '';
            notifyPagination.value.current = 1;
            notifyList();
        };

        // ==================== 业务通知记录 ====================
        const businessData = ref([]);
        const businessDetail = ref({});
        const businessDetailOpen = ref(false);
        const businessQuery = reactive({
            outTradeNo: '',
            status: undefined,
            beginTime: '',
            endTime: '',
        });
        const businessPagination = ref({
            current: 1,
            pageSize: 10,
            total: 0,
            showSizeChanger: true,
            showQuickJumper: true,
            onChange: (page, pageSize) => {
                businessPagination.value.current = page;
                businessPagination.value.pageSize = pageSize;
                businessList();
            },
            position: ['bottomLeft'],
        });
        const businessColumns = [
            { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: '16%' },
            { title: '支付单号', dataIndex: 'outTradeNo', key: 'outTradeNo', width: '22%' },
            { title: '状态', dataIndex: 'status', key: 'status', width: '11%' },
            { title: '重试次数', dataIndex: 'retryCount', key: 'retryCount', width: '8%' },
            { title: '下次重试时间', dataIndex: 'nextRetryTime', key: 'nextRetryTime', width: '14%' },
            { title: '最后错误', dataIndex: 'lastError', key: 'lastError', width: '18%' },
            { title: '操作', dataIndex: 'operation', key: 'operation', width: '11%' },
        ];

        const businessList = async () => {
            const response = await payBusinessNotifyPage({
                pageNumber: businessPagination.value.current,
                pageSize: businessPagination.value.pageSize,
                outTradeNo: businessQuery.outTradeNo || undefined,
                status: businessQuery.status ?? undefined,
                beginTime: businessQuery.beginTime || undefined,
                endTime: businessQuery.endTime || undefined,
            });
            if (response.code === 200) {
                const page = response.data || {};
                businessPagination.value.total = page.totalRow || page.total || 0;
                businessData.value = page.records || [];
            } else {
                message.error(response.msg || '查询失败');
            }
        };

        const showBusinessDetail = async (id) => {
            const response = await payBusinessNotifyInfo(id);
            if (response.code === 200) {
                businessDetail.value = response.data || {};
                businessDetailOpen.value = true;
            } else {
                message.error(response.msg || '查询详情失败');
            }
        };

        // 重推：后端把记录重置为待通知，由支付服务重试任务发送
        const retry = async (id) => {
            const response = await retryPayBusinessNotify(id);
            if (response.code === 200) {
                message.success(response.msg || '已重新入队，稍后自动发送');
            } else {
                message.error(response.msg || '重推失败');
            }
            businessList();
        };

        const onBusinessSearch = () => {
            businessPagination.value.current = 1;
            businessList();
        };

        const onBusinessReset = () => {
            businessQuery.outTradeNo = '';
            businessQuery.status = undefined;
            businessQuery.beginTime = '';
            businessQuery.endTime = '';
            businessPagination.value.current = 1;
            businessList();
        };

        // 消息报文为明文 JSON，格式化展示；非 JSON 原样返回
        const formatJson = (text) => {
            if (!text) return '';
            try {
                return JSON.stringify(JSON.parse(text), null, 2);
            } catch {
                return text;
            }
        };

        // 1=绿（通过/成功）、0=红（失败）
        const flagLabel = (options, value) => {
            const hit = options.find(item => item.value === value);
            return hit ? hit.label : '-';
        };
        const flagColor = (value) => (value === 1 ? 'green' : (value === 0 ? 'red' : 'default'));

        const notifyStatusLabel = (status) => (NOTIFY_STATUS_MAP[status] ? NOTIFY_STATUS_MAP[status].label : '-');
        const notifyStatusColor = (status) => (NOTIFY_STATUS_MAP[status] ? NOTIFY_STATUS_MAP[status].color : 'default');

        notifyList();

        const onTabChange = (key) => {
            // 切到业务通知时再首次加载
            if (key === 'notify') {
                notifyList();
            } else {
                businessList();
            }
        };

        return {
            VERIFY_OPTIONS,
            PROCESS_OPTIONS,
            NOTIFY_STATUS_OPTIONS,
            activeTab,
            notifyData,
            notifyDetail,
            notifyDetailOpen,
            notifyQuery,
            notifyPagination,
            notifyColumns,
            businessData,
            businessDetail,
            businessDetailOpen,
            businessQuery,
            businessPagination,
            businessColumns,
            SearchOutlined,
            RedoOutlined,
            flagLabel,
            flagColor,
            notifyStatusLabel,
            notifyStatusColor,
            formatJson,
            showNotifyDetail,
            showBusinessDetail,
            retry,
            onNotifySearch,
            onNotifyReset,
            onBusinessSearch,
            onBusinessReset,
            onTabChange,
            h,
        };
    },
};
</script>

<style scoped>
.tab-container {
    margin: 0 10px 10px;
}

.search-bar {
    flex-wrap: wrap;
    align-items: center;
}

.tabInput {
    width: auto;
    margin: 0 12px 10px 0;
}

.query-label {
    white-space: nowrap;
}

.search-select {
    width: 140px;
}

.tab-button {
    width: auto;
    flex: 1;
    margin-bottom: 10px;
}

.my-custom-table {
    display: flex;
    flex-direction: column;
}

.my-custom-table :deep(.ant-tabs) {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.my-custom-table :deep(.ant-tabs-content-holder) {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.my-custom-table :deep(.ant-tabs-content) {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.my-custom-table :deep(.ant-tabs-tabpane) {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.payload-pre {
    margin: 0;
    max-height: 220px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-all;
    font-size: 12px;
    line-height: 1.6;
}

.payload-tip {
    margin-top: 12px;
    color: #999;
    font-size: 12px;
}
</style>
